<template>
  <Tabs v-model:value="activeTab" class="text-lg border-surface-100 border-1 border-t-0 dark:border-surface-900 rounded-b-lg shadow">
    <TabList>
      <Tab v-for="(tab, index) in tabs" :value="index">
        <span class="font-bold">{{ tab.label }}</span>
      </Tab>
    </TabList>
  </Tabs>
  <Skeleton v-if="waivers == null || userEntity == null" height="500px" class="w-full py-2"> </Skeleton>
  <WaiversTable
    v-if="activeTab === 0 && waivers && userEntity"
    v-model:waivers="waivers.waivers"
    v-model:waiverDescriptions="waivers.waiverDescriptions"
    :userEntity="userEntity"
    :projectId="project.projectInfo.projectId"
    :permissions="permissions"
    :can-edit="canEdit"
  ></WaiversTable>
  <SimpleWaiversTable
    v-if="activeTab === 1 && waivers"
    v-model:simpleWaivers="waivers.simpleWaivers"
    :projectId="project.projectInfo.projectId"
    :can-edit="canEdit"
  ></SimpleWaiversTable>
  <TabbedWaiversTable
    v-if="activeTab === 2 && waivers"
    v-model:tabbedWaiverTabs="waivers.tabbedWaiverTabs"
    :projectId="project.projectInfo.projectId"
    :can-edit="canEdit"
  ></TabbedWaiversTable>
  <div class="flex justify-between">
    <SubmitOptions @cancelled="$emit('cancelled')" @submitted="submitWaiverChanges"></SubmitOptions>
  </div>
</template>

<script setup lang="ts">
import type { Project } from "@/types/Projects";
import type { Entity } from "@/types/Entity";
import { type Waivers, WaiversSchema } from "@/types/Waiver";
import { getUserEntity } from "@/services/Utility";
import type { UserPermissions } from "@/types/User";

const emit = defineEmits<{
  cancelled: [];
  submitted: [];
}>();

interface Props {
  project: Project;
  permissions: UserPermissions;
  canEdit: boolean;
}
const props = defineProps<Props>();

const waivers = ref<Waivers>();
const userEntity = ref<Entity | null>(null);
const activeTab = ref(0);

const tabs = ref([
  { label: "Waivers", icon: "", visible: true },
  { label: "Simple Waivers", icon: "", visible: true },
  { label: "Tabbed Waivers", icon: "", visible: true },
]);

const submitWaiverChanges = (): void => {
  axios
    .post(`/waivers/${props.project.projectInfo.projectId}/${props.project.projectDrawInfo.drawId}`, waivers.value, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      emit("submitted");
      success("Waivers Updated", "");
    })
    .catch((e) => errorApi(e));
};

onBeforeMount(async (): Promise<void> => {
  axios
    .get(`/waivers/${props.project.projectInfo.projectId}/${props.project.projectDrawInfo.drawId}`)
    .then((response) => (waivers.value = WaiversSchema.parse(response.data.result)))
    .catch((e) => errorApi(e));

  getUserEntity().then((result: Entity | null) => (userEntity.value = result));
});
</script>
